import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonContent } from '@ionic/react'
import { MktLoading } from '@cps'
import './index.scss'

import codeSendBgImg from '@img/mkt/codeSendBg.jpeg'

interface IProps {
  showLoading?: boolean;
  bgImg?: string;
  children?: any;
}

const ActivityPage: FC<IProps> = (props: IProps) => {
  const { children, showLoading = false, bgImg } = props
  return (
    <IonPage className='all-activity-page'>
      <IonContent>
        {
          showLoading
            ? <MktLoading></MktLoading>
            : (
              <div className='coupon-send-body'>
                <div className='coupon-send-bg' style={{ backgroundImage: `Url(${bgImg || codeSendBgImg})` }}></div>
                {children && children}
              </div>
            )
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(ActivityPage)
